import React from "react";
import get from "lodash/get";

import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import { CachedMicrolink } from "components/common/CachedMicrolink";
import { FIELDS, FIELDS_DEFAULT } from "constants/PostFormFields";
import { PlatformNameToPlatformTypeMap } from "features/post/format-post";
import { findManualPlatform } from "utils/accounts";

import "./post-url-preview.css";

export function shouldShowPostUrl(post, account) {
  if (!post.redirectUrl) return false;

  const supportsNotificationsAndNormalPosting = [
    PlatformNameToPlatformTypeMap.tiktok,
    PlatformNameToPlatformTypeMap.threads,
  ].includes(account?.platformType);

  if (!supportsNotificationsAndNormalPosting) return true;

  const isManualTikTokPost = account && findManualPlatform([account], "TT");
  const isManualThreadsPost = account && findManualPlatform([account], "TH");
  const isNotification = get(
    post,
    FIELDS.POST_IS_NOTIFICATION_ONLY,
    FIELDS_DEFAULT.IS_NOTIFICATION_POST_ONLY_DEFAULT
  );

  return Boolean(isManualTikTokPost || isManualThreadsPost || isNotification);
}

export function PostLink({ url, errorMessage }) {
  return (
    <ErrorBoundary
      errorMessage={<div className="text-red-500">{errorMessage}</div>}
    >
      <div className="post-url-preview h-24 w-full overflow-hidden rounded-[8px]">
        <CachedMicrolink url={url} className="m-0" media={["image", "logo"]} />
      </div>
    </ErrorBoundary>
  );
}
